/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-74ef9ead.js';
import React from 'react';
import '../config-provider/index.js';
import ConfigContext from '../config-provider/ConfigContext.js';
import '../config-provider/ConfigProvider.js';
import '../_chunks/dep-7a9656a6.js';
import '../_chunks/dep-5eadc4f3.js';
import '../_chunks/dep-fd215ab0.js';
import '../_chunks/dep-8127363b.js';
import '../_chunks/dep-a0b71ae4.js';
import '../_chunks/dep-670cc86e.js';
import '../_chunks/dep-da112583.js';
import '../_chunks/dep-dfae10c3.js';
import '../_chunks/dep-f4495ac9.js';
import '../_chunks/dep-6c09308a.js';
import '../_chunks/dep-4ca52001.js';
import '../_chunks/dep-408df89a.js';
import '../_chunks/dep-e755a9cb.js';
import '../_chunks/dep-1e4c771d.js';
import '../_chunks/dep-15d0e734.js';
import '../_chunks/dep-b0c02324.js';
import '../_chunks/dep-a09b6dac.js';
import '../_chunks/dep-1792ab93.js';
import '../_chunks/dep-9c2f4c72.js';
import '../_chunks/dep-da7344ec.js';
import '../_chunks/dep-01fe0fd1.js';
import '../_chunks/dep-20a8e46d.js';
import '../_chunks/dep-9d067299.js';
import './zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_common/js/global-config/default-config.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function useLocaleReceiver(componentName, defaultLocale) {
  var _React$useContext = React.useContext(ConfigContext),
    globalConfig = _React$useContext.globalConfig;
  function transformLocale(pattern, placement) {
    var REGEXP = /\{\s*([\w-]+)\s*\}/g;
    if (typeof pattern === "string") {
      if (!placement || !REGEXP.test(pattern)) return pattern;
      var translated = pattern.replace(REGEXP, function (_, key) {
        if (placement) return String(placement[key]);
        return "";
      });
      return translated;
    }
    if (Array.isArray(pattern)) {
      return pattern.map(function (p, index) {
        var translated = p.replace(REGEXP, function (_, key) {
          if (placement) return String(placement[index][key]);
          return "";
        });
        return translated;
      });
    }
    if (typeof pattern === "function") {
      return pattern(placement);
    }
    return "";
  }
  var componentLocale = React.useMemo(function () {
    var locale = defaultLocale || {};
    var connectLocaleByName = globalConfig[componentName];
    var localeFromContext = componentName && globalConfig ? connectLocaleByName : {};
    return _objectSpread(_objectSpread({}, typeof locale === "function" ? locale() : locale), localeFromContext || {});
  }, [componentName, defaultLocale, globalConfig]);
  return [componentLocale, transformLocale];
}

export { useLocaleReceiver };
//# sourceMappingURL=LocalReceiver.js.map
